// extracted by mini-css-extract-plugin
export var container = "_9t-0";
export var icon = "_9t-1";
export var text = "_9t-2";